/***
*
*   HOMEPAGE
*   Homepage template with features, testimonials and CTA
*
**********/

import React, { Fragment } from 'react';
import { Row, Button, Hero, Features, Testimonial } from 'components/lib';
import ImgDashboard from './images/dashboard.png';
import ImgKyleGawley from './images/kyle-gawley.jpg';

export function Home(props){

  return(
    <Fragment>

      <Hero
        title='Create how-to guides, in seconds'
        tagline='Splainy captures what you do on your screen and creates a visual step-by-step guide, in seconds.'
        image={ ImgDashboard }
      />

      <Row title='Features' color='white'>
        <Features />
      </Row>

      <Row color='brand'>
        <Testimonial
          text='Splainy rocks!'
          author='John Doe, Splainy Founder'
          image={ ImgKyleGawley }
        />
      </Row>

      <Row title='Create your first guide' align='center'>
        <Button goto='/signup' text='Sign Up Now' className='inline-block' big/>
      </Row>
    </Fragment>
  );
}
